import { createSelector } from '@reduxjs/toolkit';
import { selectGarageUtilitiesValue } from './selectGarageUtilitiesValue';
import { EGarageUtility } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Электричество', value: EGarageUtility.Electricity },
  { label: 'Вода', value: EGarageUtility.Water },
  { label: 'Отопление', value: EGarageUtility.Heating },
  { label: 'Система пожаротушения', value: EGarageUtility.ExtinguishingSystem },
];

export const selectGarageUtilitiesFilter = createSelector(selectGarageUtilitiesValue, value => ({
  label: 'Коммуникации',
  value,
  options: OPTIONS,
}));
